import { render } from "./RentMeAccept.vue?vue&type=template&id=54fb4955&scoped=true"
import script from "./RentMeAccept.vue?vue&type=script&lang=js"
export * from "./RentMeAccept.vue?vue&type=script&lang=js"

import "./RentMeAccept.vue?vue&type=style&index=0&id=54fb4955&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fb4955"]])

export default __exports__